import React from "react";

function InputModal({
  open,
  title,
  label,
  placeholder,
  value,
  onChange,
  onCancel,
  onConfirm,
}) {
  React.useEffect(() => {
    if (open) onChange("");
  }, [open, onChange]);

  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(30,41,59,0.25)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: 18,
          boxShadow: "0 8px 32px 0 rgba(31,38,135,0.18)",
          padding: "2.5rem 2.5rem 2rem 2.5rem",
          minWidth: 340,
          maxWidth: "90vw",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 38, marginBottom: 12 }}>📁</div>
        <h2
          style={{ margin: 0, fontWeight: 700, fontSize: 22, color: "#2563eb" }}
        >
          {title}
        </h2>
        <label
          style={{
            color: "#64748b",
            margin: "18px 0 10px 0",
            fontSize: 16,
            fontWeight: 500,
          }}
        >
          {label}
        </label>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          style={{
            padding: "0.7em 1em",
            borderRadius: 8,
            border: "1.5px solid #c7d2fe",
            fontSize: 16,
            width: 220,
            marginBottom: 18,
            outline: "none",
            boxShadow: "0 1px 4px 0 rgba(102,126,234,0.07)",
          }}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === "Enter") onConfirm();
          }}
        />
        <div style={{ display: "flex", gap: 18, marginTop: 8 }}>
          <button
            className="btn btn-secondary btn-sm"
            style={{ minWidth: 90, fontWeight: 600, borderRadius: 8 }}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary btn-sm"
            style={{ minWidth: 90, fontWeight: 600, borderRadius: 8 }}
            onClick={onConfirm}
            disabled={!value.trim()}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
}

export default InputModal;
